import { CommonQuestionKeys, FieldType } from '@bybeam/platform-types';
import QUESTIONS from './questions.js';
import { SpecialSectionKeys, StandardComponents } from './types.js';

const SECTIONS = {
  review: {
    key: SpecialSectionKeys.Review,
    name: 'Review',
    overview: {
      description: `
Please make sure all the information you provided is correct, so we can review your
application as soon as possible.`,
      title: 'Review your application',
    },
    questionGroups: [
      {
        key: 'submission.assistance',
        name: 'Application Assistance',
        questions: [QUESTIONS[CommonQuestionKeys.APPLICATION_ASSISTANCE_HELPER]],
      },
      {
        key: CommonQuestionKeys.AFFIRMATION,
        name: 'Affirmation',
        questions: [
          {
            key: CommonQuestionKeys.AFFIRMATION,
            copy: {
              title: 'Before submitting the application, please confirm this statement:',
              intro: 'Please review and confirm the statement by selecting the checkbox below.',
            },
            fields: [
              {
                type: FieldType.Checkbox,
                key: CommonQuestionKeys.AFFIRMATION,
                copy: "I, {APPLICANT_NAME}, certify under penalty of law, based on information and belief formed after reasonable inquiry, the statements and information contained in these documents are true, accurate and complete. I acknowledge that my information can be used by {PARTNER_NAME}'s staff to refer me to other programs.",
              },
            ],
          },
        ],
      },
    ],
  },
} as StandardComponents['definitions']['sections'];
export default SECTIONS;
